// src/lib/utils/DateTimeUtils.ts
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';

export class DateTimeUtils {
    static formatDate(dateString: string, formatString: string = 'yyyy/MM/dd HH:mm', locale: any = 'ja-JP'): string {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    }
    
     
    static formatTimeToHHMMSS(seconds: number): string {
        const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${h}:${m}:${s}`;
    }
  
    static getCountdown(scheduledTime: string): string {
      const now = new Date();
      const scheduled = new Date(scheduledTime);
      const diff = scheduled.getTime() - now.getTime();
      
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  
      if (hours > 0) {
        return `${hours}時間後`;
      } else {
        return `${minutes}分後`;
      }
    }
  
    static getDateRange(dateString: string): { start: string; end: string } {
      return {
        start: `${dateString}T00:00:00Z`,
        end: `${dateString}T23:59:59Z`
      };
    }
  
    static isStreamLive(now: Date, scheduledStartTime: Date | null): boolean {
      return scheduledStartTime !== null && now >= scheduledStartTime;
    }
  
    static isStreamEnded(now: Date, publishedTime: Date): boolean {
      return now.getTime() - publishedTime.getTime() > 10 * 60 * 1000;
    }
  
    static calculateDateDifference(startDate: string, endDate: string): { days: number, hours: number, minutes: number } {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diff = end.getTime() - start.getTime();
  
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  
      return { days, hours, minutes };
    }
    
    static formatTimeRange(dateString: string): string {
        const date = new Date(dateString);
        const hours = date.getHours();
        if (hours < 6) return '00:00 - 06:00';
        if (hours < 12) return '06:00 - 12:00';
        if (hours < 19) return '12:00 - 19:00';
        return '19:00 - 24:00';
    }

    // 2021-09-01T12:00:00Z -> 9月1日(水) 21:00
    static formatScheduledStartTime(dateString: string): string {
        const date = new Date(dateString);
        return format(date, 'M月d日(E) HH:mm', { locale: ja });
    }

    static convertToISODate(scheduledStartTime: string): Date {
        // フォーマットをISO 8601に変換
        const isoString = scheduledStartTime.replace(' ', 'T');
        return new Date(isoString);
    }

    static updateElapsedTimes(liveChannels: any[], elapsedTimes: Record<string, string>): Record<string, string> {
        liveChannels.forEach(channel => {
            if (!channel.scheduled_start_time) {
                // scheduled_start_timeがない場合はLIVEと表示
                elapsedTimes = { ...elapsedTimes, [channel.live_video_id]: 'LIVE' };
                return;
            }
    
            const startTime = DateTimeUtils.convertToISODate(channel.scheduled_start_time);
            if (isNaN(startTime.getTime())) {
                // console.error(`Invalid date format for channel ID: ${channel.live_video_id}, scheduled_start_time: ${channel.scheduled_start_time}`);
                return;
            }
            const now = new Date();
            const seconds = Math.floor((now.getTime() - startTime.getTime()) / 1000);
            elapsedTimes = { ...elapsedTimes, [channel.live_video_id]: DateTimeUtils.formatTimeToHHMMSS(seconds) };
        });
        return elapsedTimes;
    }
  }